<template>
    <div class="col-sm-12">
    <h3>{{ $t('areas.select_company') }}</h3>

        <div
            v-if="results.length > 0"
            class="col-12 nopads"
        >
            <div
                v-for="result in results"
                :key="result.id"
                class="inspection-selector d-flex align-items-center"
                @click.stop="$emit('onCompanySelected', result)"
            >
                <div class="item-img-cont me-2">
                    <font-awesome-icon icon="building" style="color: #FFFFFF"/>
                </div>
                <div class="item-text-cont" style="color: #FFFFFF">
                    {{ result.name }}
                </div>
            </div>

        </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'

export default {
    name: 'ContractorSelector',
    mixins: [restApi],
    data: function () {
        return {
            loading: false,
            results: []
        }
    },
    created: function () {
        this.fetchContractors()
    },
    methods: {
        fetchContractors: function () {
            this.loading = true
            this.restFetchParams(this.contractorUrl, {}, this.handleResponse)
        },
        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        }
    }
}
</script>
